import React from "react";
import type { BaseLogEntry } from "../types";
import { styles } from "../../styles";

/** This panel must work without a hosted inbox or authenticated service session. */
export function OnchainRecoveryPanel({
  ready,
  busy,
  logs,
  onRefresh,
}: {
  ready: boolean;
  busy: boolean;
  logs: BaseLogEntry[];
  onRefresh: () => void | Promise<void>;
}) {
  return (
    <section aria-label="On-chain wallet recovery">
      <h2>Recovery &amp; activity</h2>
      <p>
        Your 12-word StealthOS recovery phrase restores your private wallet on
        Base, Doge and Solana. Encrypted note data is read directly from the
        blockchain.
      </p>
      <button
        type="button"
        style={{ ...styles.button, ...styles.secondaryButton }}
        disabled={!ready || busy}
        onClick={() => void onRefresh()}
      >
        {busy ? "Recovering notes…" : "Refresh recovery"}
      </button>
      <details open>
        <summary>Recent recovery activity</summary>
        {logs.length ? (
          logs.slice(0, 50).map((entry) => (
            <p
              key={entry.id}
              role={
                entry.type === "warning" || entry.type === "error"
                  ? "alert"
                  : "status"
              }
            >
              {entry.timestamp.toLocaleTimeString()} · {entry.message}
            </p>
          ))
        ) : (
          <p>No recovery activity in this session.</p>
        )}
      </details>
    </section>
  );
}
